<template>
  <div>
    <label class="typo__label text-primary"> <span class="text-danger">* </span> Agregar modulos a este programa:</label>
    <div class="row"> 
      <div class="col-sm-11">
        <multiselect v-model="values" id="id" label="nombre" track-by="id" placeholder="Escriba Aqui Todo o parte del nombre del modulo...(de 3 letras minimo, si no lo encuentra use el cuadro de abajo para agregar)" 
          open-direction="bottom" :options="datos" :multiple="true" 
          :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="true" :close-on-select="true" 
          :options-limit="300" :limit="24" :limit-text="limitText" :max-height="600" :show-no-results="true" 
          :hide-selected="true" :show-labels="false" @search-change="asyncFind">

          <template slot="tag" slot-scope="{ option, remove }">
            <div>
              <span class="custom__tag">
                <span class="custom__remove" @click="remove(option)">❌</span>
                <span>{{ parseLabel(option) }}</span>
              </span>
            </div>
          </template>
          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear" v-if="modelo==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
          </template>
          <span slot="noResult">Modulo no encontrado</span>
        </multiselect>
      </div>

      <div class="col-sm-1">
        <button type="button" class="btn btn-sm btn-link" @click="asyncFind(beforeQuery)">Mas</button>
      </div>
    </div>
    <br>


    <div class="row">
      <div class="col-sm-4"> 
         <div class="input-group input-group-sm" v-if="values.length>0">
           <span class="input-group-addon" id="basic-addon1"> Numero inicial del modulo: </span>
           <input type="number" v-model.trim="numero" class="form-control" placeholder="Numero inicial de modulo">
          </div>
      </div>
    </div>
    <p></p>
    <div class="form-group" style="margin-bottom:14px;background:#DDDDDD;padding:8px;border:1px solid #dfdfdf;margin-left:15px;margin-right:15px" v-bind:key="ind" v-for="(v,ind) in values">
      <div class="input-group input-group-sm">
        <div class="input-group-addon">No. <input class="xinput" type="number" v-model="v.numero" style="max-width:40px"/> :</div>
        <input type="text" class="xinput form-control" placeholder="Modulo" :value="v.nombre" style="min-width:320px">
        <div class="input-group-addon">Inicio:</div>
        <Fecha class="xinput" :model="v" :valueto="'inicio'" :default="v.inicio" style="max-width:150px"/> 
        <div class="input-group-addon">Fin:</div>
        <Fecha :model="v" :valueto="'fin'" :default="v.fin" style="max-width:150px"/>
        <div class="input-group-addon dedito" @click="editarmodulo(v)" title="Editar modulo" data-toggle="modal" data-target="#modal-editmod" style="margin:8px!important"> <span class="glyphicon glyphicon-pencil"></span> </div>        
        <button type="button" @click="editarmodulo(v)" class="btn btn-sm btn-link" data-toggle="modal" data-target="#modal-asig-aula">
          Aula
        </button>
      </div>
      {{parseDefaulfDoc(v.iddocente)}}
      <BuscarDocente :model="v" :default="v.iddocente"/>
      <span v-if="v.aula">
        <b>Aula:</b> {{v.aula.aula}} <b>sede:</b> {{v.aula.sede}}
      </span>
    </div>
    <button type="button" @click="sortModulos()" class="btn btn-default btn-sm">Ordenar por numero</button>

  <EditMod :mod="modedit"/>
  <notifications group="auth4" position="bottom right" />
  <Aulas :mod="modedit"/>
  </div>
</template>

<style lang="css">
  .input-group-addon{ 
    padding: 0px 6px 0px 6px!important; 
  }
  .dedito:hover{cursor: pointer;}
</style>

<script>
import gql from 'graphql-tag'
import Fecha from '@/components/AFecha.vue'
import EditMod from '@/components/AEditarMod.vue'
import BuscarDocente from '@/components/ABuscarDocentes.vue'
import Aulas from '@/views/AsignarAulasModal'
import {parseJsonError,error2} from '@/components/Utils.js'

export default {
  props:{ 
    model:{type:Object,required:true},
    importado:{type:Object,required:true},
    default:{type:Array,required:false,default:null},
  },
  data () {
    return {
      modedit:{},
      isLoading: false,
      numero: 0,
      datos: [],
      beforeQuery: '',
      modelo: {
        idestudiante: null,
      },
      cursor: 100000,
      values: [],
    }
  },
  watch:{
    values:{
      deep: true,
      handler(){
        var vue = this;
        this.values.forEach( function(e,ind){
          if( e.numero==-1 ) e.numero = ind+vue.getNumero();
          if( typeof(e.numero) != Number ){
            try { e.numero = parseInt(e.numero)
            } catch (error) { window.console.error(error)}
          } 
        })
        this.model.modulos = this.values;
        //window.console.log( "//////////////", window.stringifyObject(this.values) )
      }
    }, 
    default:{
      deep: true,
      handler(){
        //if( a == null ) return;
        var vue = this;
        this.default.forEach( function(e,ind){
          if( e.numero == null ) e.numero = ind+vue.getNumero();
        })
        this.values = this.default;
        //window.console.log( "MODDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDd",this.default )
      }
    },
    'importado.intereses': function(a){
      if( a == null ) return;
      //window.console.log( "IMPORTADOOOOO ",a );
      this.asyncImportar( a.idpostgrado );
    },
  },
  components:{ Fecha,EditMod,BuscarDocente,Aulas },
  methods: {
    parseDefaulfDoc( d ){
      if( d == null ) return "";
      if( typeof(d) == 'number') return "";
      if( d.nombre ) return d.nombre;
      
      if( d.seg_apellido == null ) d.seg_apellido = "";
      return d.nombres+' '+d.pri_apellido+' '+d.seg_apellido+' - '+d.num_doc;
    },
    getNumero(){
      var num = parseInt(this.numero);
      if( isNaN(num) ) return 0;
      return num;
    },
    parseLabel( option ){
      if( option == null ) return "";
      //return option.sigla + " - "+option.nombre;
      return option.nombre;
    },
    limitText (count) {
      return `and ${count} other countries`
    },
    async asyncFind (query) {
      query = query.trim();
      if( query.length <= 2 ) return;
      if( this.beforeQuery != query ){
        this.beforeQuery = query;
        this.cursor = 100000;
        this.datos = [];
      }
      this.isLoading = true
      var vue = this;
      var sql = gql`query{ getModulos(cursor:${this.cursor},nombre:"${query}"){ id,nombre,sigla,tipo } }`;
      //window.console.log( "\n\n***********************************************",sql );

      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        var datas = data.data.getModulos;
        vue.isLoading = false;
        var dat = datas.concat( vue.datos )
        dat.forEach( function(e){
          e.numero = -1
        })
        vue.datos = dat;
        if( datas.length > 0 ) vue.cursor = datas[datas.length-1].id;
        //window.console.log( datas,vue.datos,vue.cursor )

      }).catch((error) => {
        window.console.error(error)
        vue.isLoading = false
        vue.$notify( parseJsonError( error,'getModulos' ) )
      })
    },
    async asyncImportar ( idprograma ) {
      var vue = this;
      var sql = gql`query{getProgramaByPostgrado(id:${idprograma}){programa_modulos{ numero,modulo{id,nombre,sigla,tipo} }}}`;
      window.console.log( "\n\n***********************************************",sql );

      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        // window.console.log( data.data.getProgramaByPostgrado )
        if( data.data.getProgramaByPostgrado ){
          var dats = data.data.getProgramaByPostgrado.programa_modulos;
          var dts = [];
          dats.sort(function(a, b){return a.numero - b.numero});
          dats.forEach( function(e){
            dts.push( {id:e.modulo.id, nombre:e.modulo.nombre, sigla:e.modulo.sigla,numero:e.numero,aula:{}} )
          })
          vue.values = dts;
        }

      }).catch((error) => {
        window.console.error(error)
        vue.isLoading = false
        vue.$notify( parseJsonError( error,'getModulos' ) )
      })
    },
    sortModulos(){
      var vue = this;
      this.values.sort(function(a, b){return a.numero - b.numero});
      this.values.forEach( function(e,ind){
        e.numero = ind+vue.getNumero();
      })
    },
    clearAll () {
      this.modelo.idestudiante = null;
    },
    editarmodulo( mod ){
      if( !this.$store.state.updateModulo ){
        this.modedit = {};
        this.$notify( error2( 'Editar modulo','No tienes permiso para realizar esta accion',4000 ) )
        window.$('#modal-editmod').modal('toggle');
        return;
      }
      delete mod.__typename;
      var obj = window.Object.assign({},mod)
      delete obj.numero;
      this.modedit = obj;
      window.console.log( mod )
      window.sessionStorage.setItem( 'xeditmod',JSON.stringify(mod) );
    },
  },
  mounted(){
    if( this.default ){
      /*this.default.forEach( function(e){
        
      })*/
      this.values = this.default;
    }
  }
}
</script>